/*
 * Jira Ticket:
 * Created Date: Fri, 27th Mar 2020, 14:32:33 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Edit,
  FormDataConsumer,
  // Labeled,
  SaveButton,
  SimpleForm,
  TextInput,
  usePermissions,
  useTranslate,
  Title
} from 'react-admin';
import { connect } from 'react-redux';
import { TemplateToolbar } from 'Components';
import RichTextInput  from 'ra-input-rich-text';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';

const selectorContainer = '.simple-form'; // use this to set the bounds for the rich text editor link component

const SaveOnlyToolbar = props => {
  return <TemplateToolbar children={<SaveButton {...props} />} {...props} />;
};

// Add back in if the client requests it
// const VariablesField = ({ record }) => {
//   return (
//     <div>
//       <ul>
//         {record.variables.map(variable => (
//           <li key={variable.tag}>
//             {variable.tag} - {variable.description}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

const TemplateEdit = ({ dispatch, formValues, ...props }) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return isSuperAdmin(permissions) ? (
    <>
    <Title title={`resources.General.cmsTitle`} />
    <Edit
      title={translate('resources.Template.fields.editTitle', {
        templateName:
          props.id && formValues[props.id] && formValues[props.id].name,
      })}
      undoable={false}
      {...props}
    >
      <SimpleForm redirect={false} toolbar={<SaveOnlyToolbar />}>
        {/* Add back in below if the client requests it */}
        {/* <FormDataConsumer>
          {({ formData }) =>
            formData.variables && formData.variables.length > 0 ? (
              <Labeled
                label="resources.Template.fields.variables"
                helperText="Hiya"
              >
                <VariablesField record={formData} />
              </Labeled>
            ) : null
          }
        </FormDataConsumer> */}
        <FormDataConsumer>
          {({ formData }) =>
            formData.subject ? (
              <TextInput
                source="subject"
                fullWidth
                label="resources.Template.fields.subject"
              />
            ) : null
          }
        </FormDataConsumer>
        <RichTextInput
          source="content"
          options={{ bounds: selectorContainer }}
          label={props.id && formValues[props.id] && formValues[props.id].name}
        />
      </SimpleForm>
    </Edit>
    </>
  ) : (
    <AccessDenied />
  );
};

const mapStateToProps = state => {
  return {
    formValues:
      state.admin.resources.Template && state.admin.resources.Template.data,
  };
};

export default connect(mapStateToProps)(TemplateEdit);
